import { render } from "./Pass.vue?vue&type=template&id=62c3cf55"
import script from "./Pass.vue?vue&type=script&lang=js"
export * from "./Pass.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__